// This file contains all the js imports to get "legacy" js working. Legacy JS
// refers to JS that was written with sprockets as the asset pipeline library.
// Set properties on `window` so they are globally available outside of js that
// is compiled as part of the asset bundle.
import d3 from 'd3';

import '../../node_modules/bootstrap/dist/js/bootstrap.min.js';
// TODO: Write test cases to exercise the functionality in the scripts imported
// below
import './application/javascripts/analytics/google';
import {
  analyticsIdentify,
  analyticsTrack,
  getAnalyticsDestination,
} from './application/javascripts/analytics_util';
import './application/javascripts/anchor-link';
import engine from './application/javascripts/app';
import {
  createLeadWithApple,
  logInWithApple,
  unlockContentWithApple,
} from './application/javascripts/apple-login';
import './application/javascripts/articles/featured';
import './application/javascripts/comments/comment-form';
import './application/javascripts/comments/comment-thread';
import './application/javascripts/comments/like';
import './application/javascripts/emailCapture';
import './application/javascripts/forms/locked-homepage-lead-capture';
import {
  createLeadWithGoogle,
  logInWithGoogle,
  unlockContentWithGoogle,
} from './application/javascripts/google-login';
import './application/javascripts/newsletter-card';
import './application/javascripts/newsletter-share-modal';
import './application/javascripts/newsletter_feed';
import './application/javascripts/newsletter_index';
import createAhoyEvent from './application/javascripts/payments/stripe/analytics';
import './application/javascripts/payments/stripe/analytics';
// import files not directly referenced. Most of these setup event handlers or
// call some function that needs to be ran when the pack bundle is loaded.
import trackEvent, { trackAhoyEventOnly } from './application/javascripts/tracking';
import './application/javascripts/url/clean-params';
import { dispatchScriptLoadedEvent, ready } from './application/javascripts/utils';
import initializeEmbeddedVideos from './application/javascripts/videos/init';
import initializeTracking from './application/javascripts/videos/tracking';
import './styles/application.scss';

window.getAnalyticsDestination = getAnalyticsDestination;
window.analyticsTrack = analyticsTrack;
window.analyticsIdentify = analyticsIdentify;
window.d3 = d3;
window.initializeEmbeddedVideos = initializeEmbeddedVideos;
window.initializeTracking = initializeTracking;
window.dispatchScriptLoadedEvent = dispatchScriptLoadedEvent;
window.createAhoyEvent = createAhoyEvent;
window.trackAhoyEventOnly = trackAhoyEventOnly;
window.engine = engine;
window.trackEvent = trackEvent;
window.ready = ready;
window.logInWithGoogle = logInWithGoogle;
window.logInWithApple = logInWithApple;
window.createLeadWithGoogle = createLeadWithGoogle;
window.createLeadWithApple = createLeadWithApple;

// These functions are overriden in test files. The scoping here is not to
// satisfy an application dependency.
window.unlockContentWithGoogle = unlockContentWithGoogle;
window.unlockContentWithApple = unlockContentWithApple;

// The `render` function is similar to `timeago` which is a library that used to
// be vendor'd in via sprockets. The interface is slighty different as it
// expects either a single node or a nodeList. A query that results in an empty
// set will break.
window.timeago = (nodeList) => {
  nodeList.length > 0 && render(nodeList);
};

// These values are the same as above but are also set to be globally available
// within webpack compiled scripts. This is handled in environment.js. They are
// set on the window to satisy any expectations about how they are called.
window.Cookies = Cookies;
window.$ = $;
